module.exports = __webpack_public_path__ + "img/mock-page.8e36f6a2.png";